import axiosClient from "@/utils/axios-client";
import {
  CreateOrderSheetSetInquiryRequest,
  OrderHistoryGetDetailParams,
  OrderHistoryGetDetailResponse,
  OrderHistoryGetProformaInvoiceDetailParams,
  OrderSheetSetInquiriesParams,
  OrderSheetSetInquiriesResponse,
} from "@/features/my-order/features/order-history/types";
import { OrderHistoryOrderModificationFileRequest } from "@/features/my-order/features/order-history/features/final-copy/types";
import { ProformaInvoice } from "@/features/invoices/proforma-invoices/proforma-invoice.type";

const url = {
  getOrderHistoryDetail: ({
    companyType,
    companyId,
    orderSheetSetId,
  }: OrderHistoryGetDetailParams) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}`,
  getOrderHistoryProformaInvoiceDetail: ({
    companyType,
    companyId,
    invoiceId,
  }: OrderHistoryGetProformaInvoiceDetailParams) =>
    `/${companyType}/${companyId}/proforma-invoices/${invoiceId}`,

  postModificationFiles: (buyer_id: number, order_sheet_set_id: number) =>
    `/buyers/${buyer_id}/order-sheet-sets/${order_sheet_set_id}/create-by-fallback`,

  orderSheetSetInquiries: ({
    companyType,
    companyId,
    orderSheetSetId,
  }: OrderSheetSetInquiriesParams) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/inquiries`,

  orderSheetSetInquiriesRead: ({
    companyType,
    companyId,
    orderSheetSetId,
  }: OrderSheetSetInquiriesParams) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/inquiries/read`,
};

export const orderHistoryApi = {
  getOrderHistoryDetail: async ({
    companyType,
    companyId,
    orderSheetSetId,
  }: OrderHistoryGetDetailParams) => {
    const { data } = await axiosClient.get<OrderHistoryGetDetailResponse>(
      url.getOrderHistoryDetail({ companyType, companyId, orderSheetSetId })
    );

    return data;
  },
  getOrderHistoryProformaInvoiceDetail: async ({
    companyType,
    companyId,
    invoiceId,
  }: OrderHistoryGetProformaInvoiceDetailParams) => {
    const { data } = await axiosClient.get<ProformaInvoice>(
      url.getOrderHistoryProformaInvoiceDetail({
        companyType,
        companyId,
        invoiceId,
      })
    );

    return data;
  },

  postModificationFiles: async (
    buyer_id: number,
    order_sheet_set_id: number,
    params: OrderHistoryOrderModificationFileRequest
  ) => {
    const { data } = await axiosClient.post(
      url.postModificationFiles(buyer_id, order_sheet_set_id),
      params
    );

    return data;
  },

  getOrderSheetSetInquiries: async (params: OrderSheetSetInquiriesParams) => {
    const { data } = await axiosClient.get<OrderSheetSetInquiriesResponse>(
      url.orderSheetSetInquiries(params)
    );
    return data;
  },

  createOrderSheetSetInquiry: async (
    params: OrderSheetSetInquiriesParams,
    body: CreateOrderSheetSetInquiryRequest
  ) => {
    const { data } = await axiosClient.post<OrderSheetSetInquiriesResponse>(
      url.orderSheetSetInquiries(params),
      body
    );
    return data;
  },

  markOrderSheetSetInquiriesRead: async (
    params: OrderSheetSetInquiriesParams
  ) => {
    const { data } = await axiosClient.post(
      url.orderSheetSetInquiriesRead(params),
      {}
    );
    return data;
  },
};
